import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCalendarAppointments } from '../../redux/actions/calendar/calendar'
import Loading from '../../component/Common/Loading/Loading'
import { MessageError } from '../../component/Common/MessageError/MessageError'
import { CalendarPickerView } from 'antd-mobile'
import { Space, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import { Popup } from 'antd-mobile'


const statusColor = {
    "Pending": "#faad14",
    "Confirmed": '#108ee9',
    "Checked-in": '#722ed1',
    "Cancel": '#8c8c8c',
    "Completed": '#87d068',
    "No-show": '#fa541c'
}

const CalendarAppointments = () => {
    const [month, setMonth] = useState(dayjs().format('YYYY-MM'))
    const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'))
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { error, message, loading, appointments } = useSelector(state => state.calendar)

    const min = dayjs(month).startOf('month').toDate();
    const max = dayjs(month).endOf('month').toDate();
    const [popupVisible, setPopupVisible] = useState(false)      // add
    const [selectedDateData, setSelectedDateData] = useState(null) // add
    const [selectedDateString, setSelectedDateString] = useState('') // add

    const onChangeDate = (value) => {
        const dateString = dayjs(value).format('YYYY-MM-DD')
        setDate(dateString)

        const dateData = appointments.find(item => item._id === dateString)
        if (!dateData) return

        // replace Modal.confirm with this:
        setSelectedDateData(dateData)
        setSelectedDateString(dateString)
        setPopupVisible(true)
    }


    const countTotalAppointments = (date) => {
        let count = 0

        const dateAppointments = appointments.find(appointment => appointment._id === dayjs(date).format('YYYY-MM-DD'))
        let isToday = false
        if (dateAppointments?._id) {
            isToday = dayjs().isSame(dayjs(dateAppointments._id, "YYYY-MM-DD"), 'day');
        }

        if (dateAppointments) {
            for (let appointment of dateAppointments.appointments) {
                count += appointment.count
            }
            return <span style={{ fontSize: "14px", fontWeight: "bold", color: !isToday ? "#fa8c16" : "#ffffff" }}>{count}</span>
        } else {
            return null
        }
    }

    const renderDayAppointments = (dateData) => {
        const total = dateData.appointments.reduce((sum, a) => sum + a.count, 0)

        return (
            <div style={{ padding: "8px 4px" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "12px",
                    gap: "6px"
                }}>
                    <span style={{ fontSize: "18px", color: "#8c8c8c" }}>Total</span>
                    <span style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#fa8c16"
                    }}>{total}</span>
                    <span style={{ fontSize: "18px", color: "#8c8c8c" }}>appointments</span>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {dateData.appointments.map((appointment) => (
                        <div key={`${appointment.status}`} style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 12px",
                            borderRadius: "8px",
                            backgroundColor: `${statusColor[appointment.status]}18`,
                            borderLeft: `4px solid ${statusColor[appointment.status]}`
                        }}>
                            <span style={{
                                fontSize: "15px",
                                color: statusColor[appointment.status],
                                fontWeight: "500"
                            }}>
                                {appointment.status}
                            </span>
                            <span style={{
                                fontSize: "18px",
                                fontWeight: "700",
                                color: statusColor[appointment.status],
                                minWidth: "28px",
                                textAlign: "center",
                                backgroundColor: `${statusColor[appointment.status]}25`,
                                borderRadius: "6px",
                                padding: "0px 8px"
                            }}>
                                {appointment.count}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    useEffect(() => {
        dispatch(getCalendarAppointments(month))
    }, [dispatch, month])

    useEffect(() => {
        MessageError(message, error)
    }, [error, message])

    return (
        <div style={{ padding: "10px 0px" }}>
            <div >
                <CalendarPickerView
                    style={{ height: "max-content" }}
                    className='calendar-picker'
                    min={min}
                    max={max}
                    allowClear={false}
                    value={dayjs(date).toDate()}
                    onChange={onChangeDate}
                    renderBottom={(date) => countTotalAppointments(date)}
                    title={
                        <Space.Compact size='large' style={{ width: "100%" }}>
                            <Button
                                style={{ width: "50%" }}
                                onClick={() => setMonth(dayjs().format('YYYY-MM'))}
                                type={dayjs().format('YYYY-MM') === month ? 'primary' : 'default'}
                            >
                                {dayjs().format("MMM")}
                            </Button>
                            <Button
                                style={{ width: "50%" }}
                                onClick={() => setMonth(dayjs().add(1, "month").format("YYYY-MM"))}
                                type={dayjs().add(1, "month").format("YYYY-MM") === month ? 'primary' : 'default'}
                            >
                                {dayjs().add(1, "month").format("MMM")}
                            </Button>
                            <Button
                                style={{ width: "33.33%" }}
                                onClick={() => setMonth(dayjs().add(2, "month").format("YYYY-MM"))}
                                type={dayjs().add(2, "month").format("YYYY-MM") === month ? 'primary' : 'default'}
                            >
                                {dayjs().add(2, "month").format("MMM")}
                            </Button>
                            <Button
                                style={{ width: "33.33%" }}
                                onClick={() => setMonth(dayjs().add(3, "month").format("YYYY-MM"))}
                                type={dayjs().add(3, "month").format("YYYY-MM") === month ? 'primary' : 'default'}
                            >
                                {dayjs().add(3, "month").format("MMM")}
                            </Button>
                        </Space.Compact>
                    }
                />
            </div >
            {/* Add Popup here */}
            <Popup
                visible={popupVisible}
                onMaskClick={() => setPopupVisible(false)}
                bodyStyle={{ borderRadius: '16px 16px 0 0', padding: '20px' }}
            >
                <div style={{ fontSize: "18px", fontWeight: "500", marginBottom: "12px" }}>
                    {dayjs(selectedDateString).format('ddd, MMM D, YYYY')}
                </div>
                {selectedDateData && renderDayAppointments(selectedDateData)}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '16px' }}>
                    <Button
                        size='large'
                        type="primary"
                        block
                        onClick={() => {
                            setPopupVisible(false)
                            const target = `/?date=${selectedDateString}`;
                            navigate(target);
                        }}
                    >
                        View Date
                    </Button>
                    <Button block size='large' onClick={() => setPopupVisible(false)}>
                        Close
                    </Button>
                </div>

            </Popup>
            <Loading loading={loading} />

        </div>
    )
}

export default CalendarAppointments